import dayjs from "dayjs";

export const toDateString = (dateStr: string) => dayjs(dateStr).format("YYYY-MM-DD");
